import React from 'react';
import { Box, Paper, Typography, TextField, Button, Avatar, Stack } from '@mui/material';

const ManageProfile: React.FC = () => {
  const [avatar, setAvatar] = React.useState<string | undefined>(undefined);
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setAvatar(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 6 }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 2, border: '1px solid #E5E7EB' }}>
        <Stack alignItems="center" spacing={2} sx={{ mb: 3 }}>
          <Avatar src={avatar} sx={{ width: 80, height: 80, bgcolor: '#6366F1', fontSize: 36 }}>J</Avatar>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleAvatarChange}
          />
          <Button variant="outlined" size="small" onClick={() => fileInputRef.current?.click()}>
            Change Avatar
          </Button>
        </Stack>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: '#111827', textAlign: 'center' }}>
          Manage Profile
        </Typography>
        <TextField
          label="Name"
          value="John Doe"
          fullWidth
          margin="normal"
          disabled
        />
        <TextField
          label="Email"
          value="john.doe@example.com"
          fullWidth
          margin="normal"
          disabled
        />
        <Button variant="contained" sx={{ mt: 3 }} disabled>Edit</Button>
      </Paper>
    </Box>
  );
};

export default ManageProfile; 